<template>
  <section class="section">
    <b-loading isFullPage :active="isLoading" />
    <div class="columns">
      <div
        v-if="showCapacity"
        class="cursor-pointer is-flex is-align-items-center"
        @click="goToPartList()"
      >
        <b-icon
          :type="isContrast ? 'is-white' : 'is-blue-oil'"
          icon="arrow-left-thick"
          size="is-medium"
        />
      </div>
      <h1 class="title column is-size-5 has-text-color-7">
        {{ General.MANAGE_UNITY }}
      </h1>
    </div>
    <ManagePart v-if="!showCapacity" @showCapacity="goToCapacityList" />
    <ManageCapacity v-else :partId="partToDetail.id" />
  </section>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { General } from "@/utils/constants";
import ManagePart from "@/components/ManagePart";
import ManageCapacity from "@/components/ManageCapacity";

export default {
  name: "ManageUnity",

  components: {
    ManagePart,
    ManageCapacity
  },

  data() {
    return {
      isLoading: false,
      General,
      viewDisabled: false,
      partToDetail: null,
      showCapacity: false
    };
  },

  computed: {
    ...mapGetters({
      isContrast: "isContrast"
    })
  },

  async beforeMount() {
    this.isLoading = true;
    await this.partControlRequest();
    this.isLoading = false;
  },

  methods: {
    ...mapActions({
      partControlRequest: "partControlRequest"
    }),

    goToPartList() {
      this.showCapacity = false;
      this.partToDetail = null;
    },

    goToCapacityList(part) {
      this.showCapacity = true;
      this.partToDetail = part;
    }
  }
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/variables";

.section {
  display: flex;
  flex-direction: column;
  background-color: $color-1;
  padding: 20px 1.5rem 0 1.5rem;
}
</style>
